<template>
    <div class="phoneProductCenter">
        <div style="height: 5.29em;width:100%;position: fixed;left: 0;z-index: 10000;
        top: 0;background-color:#fff;" class="flex flex-a-c">
            <img src="../assets/img/logo.png" style="width: 8.33em;height: 1.96em;margin-left: 2.04em;" alt="">
        </div>
        <div style="height: 5.29em;"></div>
        <banner :type="3" :phone="true"></banner>
        <div style="width: 100%;height: 6.5em;background: #F7F9FA; padding: 1.92em 1.42em;" class="position-r">
            <input type="text" v-model="text" placeholder="请输入关键字或产品货号">
            <img @click="search" src="../assets/img/sousuo.svg" alt=""
                 style="position:absolute;right: 3.75em;top: 2.8em;width: 1.2em;">
        </div>
        <div style="padding: 2.17em 1.46em;">
            <div class="flex flex-wrap flex3">
                <div v-for="item in productCate" :class="{'active':item.name == productList.name}" class="cate"
                     :key="item.id" @click="getProductList(item.id)">
                    <span>{{item.name}}</span>
                </div>
            </div>
            <div style="width: 28.33em;height: 0.42em;background: #F7F9FA;border-radius: 2px;"></div>
            <div style="margin-top: 1.38rem;">{{productList.desc}}</div>
            <div style="width: 28.33em;height: 0.08em;background: #BD2C2E;border-radius: 2px;margin-top: 1.71em;"></div>
            <div class="flex table">
                <div style="flex: 0 0 5.83em;">项目名称</div>
                <div style="flex: 0 0 7.5em;">产品货号</div>
                <div style="flex: 0 0 5.75em;">产品类别</div>
                <div style="flex: 0 0 9.08em;">应用平台</div>
            </div>
            <div class="flex table" v-for="item in productList.list" :key="item.id">
                <div style="flex: 0 0 5.83em;background: #F7F9FA;">{{item.name}}</div>
                <div style="flex: 0 0 7.5em;">{{item.field1}}</div>
                <div style="flex: 0 0 5.75em;">{{item.field2}}</div>
                <div style="flex: 0 0 9.08em;">{{item.field3}}</div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'productCenter',
        components: {},
        props: {},
        data() {
            let that = this
            return {
                banner: [],
                productList: {},
                id: that.$route.query.id,
                text: '',
                productCate: [],
                productName: that.$route.query.name
            }
        },
        async mounted() {
            await this.getProductCate()
            if (this.$route.query.id) {
                this.getProductList()
            } else if (this.productCate[0]) {
                this.id = this.productCate[0].id
                this.getProductList()
            }
        },
        methods: {
            // 获取产品分类
            async getProductCate() {
                this.productCate = await this.$api.getProductCate()
            },
            // 获取产品列表
            async getProductList(id) {
                if (id) this.id = id
                this.productList = await this.$api.getProductList2({cate_id: this.id})
            },
            async search() {
                if (!this.text) return
                this.productList = await this.$api.getProductList2({cate_id: this.id, keywords: this.text})
            }
        },

    }
</script>
<style scoped lang="scss">
    .phoneProductCenter {
        font-size: 12px;
    }

    .cate {
        height: 3.2em;
        font-weight: 600;
    }

    .cate.active {
        color: $red;
    }

    .cate span {
        position: relative;

    }

    .cate.active span::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -1em;
        width: 100%;
        height: 2px;
        background: #BD2C2E;
        border-radius: 1px;

    }

    input {
        width: calc(100% - 2.92em);
        height: 2.67em;
        background: #FFFFFF;
        border-radius: 1em;
        padding: 0 0 0 2.4em;
        border: 0;
    }

    .table {
        & > div {
            height: 5.45em;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    /deep/ .swiper-pagination .swiper-pagination-bullet {
        height: .7em;
        width: .7em;
    }
</style>
